import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../../../../services/auth-api/models/user.model';
import { RoleEnum } from '../../../../../services/auth-api/enums/role.enum';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  standalone: false,
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: 'assets/images/dashboard/profile.jpg';

  constructor(public router: Router) {
    let user: User | undefined = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') ?? '')
      : undefined;
    if (user) {
      this.userName = user?.name;
    }
  }

  ngOnInit() {}

  logoutFunc() {
    localStorage.removeItem('singInReponse');
    localStorage.removeItem('user');
    this.router.navigateByUrl('auth/login');
  }
}
